export default function ServicesHero() {
  return (
    <section className="relative min-h-[70vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/481a4106eeb6fb6209555ababb719de5.jpg"
          alt="House of FMR Event Planning Services"
          title="House of FMR premium event planning and equipment hire services"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 py-32">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-px bg-amber-400"></div>
            <span className="text-amber-300/80 text-xs font-medium tracking-[0.2em] uppercase">
              Services &amp; Pricing
            </span>
          </div>

          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl font-normal leading-[1.05] tracking-tight mb-6">
            <span className="text-white">Tailored </span>
            <span className="italic text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-100 to-amber-300">
              Packages
            </span>
            <br />
            <span className="text-white">for Every Event</span>
          </h2>

          <p className="text-lg text-white/60 max-w-lg leading-relaxed mb-10">
            Transparent pricing, flexible packages, and bespoke solutions. Find the perfect plan for your celebration.
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              href="#pricing"
              className="px-8 py-4 bg-gradient-to-r from-amber-500 to-yellow-400 text-stone-900 text-sm font-semibold rounded-full hover:from-amber-400 hover:to-yellow-300 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-amber-500/25 hover:scale-105"
            >
              View Packages
            </a>
            <a
              href="#consultation"
              className="px-8 py-4 bg-white/10 border border-white/20 text-white text-sm font-medium rounded-full hover:bg-white/15 transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              Book Free Consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
